import { render, staticRenderFns } from "./EbkFuncVedom.vue?vue&type=template&id=2081f66e&"
import script from "./EbkFuncVedom.vue?vue&type=script&lang=js&"
export * from "./EbkFuncVedom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports